export default "__VITE_ASSET__BytYfUtx__"